/**
 * O cabeçalho do resultado: o estado do caso numa linha e a ação de exame ao
 * lado (E91.F2, GUS-51 RF03/RF05).
 *
 * É o que o banco procura ao chegar — "o caso está processado? posso pegar o
 * exame?" — e por isso vem antes de avisos, pendências e tabela, na preliminar
 * e na mesa. Só lê o que a página já carregou; nada é buscado aqui — salvo o quadro de informar o
 * banco do caso que nasceu sem ele, da plataforma (E177.F1, GUS-253 A1), que lista os bancos.
 *
 * E203.F1.T03 (mesa enxuta): a frase do estado ("N de N documentos verificados") saiu; o card do
 * pacote e o rodapé já dizem em que ponto o caso está. Fica a ação: "Baixar exame", com os avisos.
 *
 * E205.F2 (ADR-0147 §2): a barra da aba Exame (`MesaUnica/BarraDoExame`) tomou o lugar do componente;
 * aqui fica o estado do caso que ela marca (`data-estado`).
 */
import type { ExameEletronicoCcbData } from '@/lib/exame_eletronico';

export type EstadoDoCaso = 'sem_documentos' | 'sem_protocolo' | 'em_processamento' | 'verificados';

export function estadoDoCaso(
  pecas: readonly ExameEletronicoCcbData[],
  temProtocolo: boolean,
  emProcessamento: boolean,
): EstadoDoCaso {
  if (pecas.length === 0) return 'sem_documentos';
  if (emProcessamento) return 'em_processamento';
  if (!temProtocolo) return 'sem_protocolo';
  return 'verificados';
}
